import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'

export function hasCollectionPointOptionSelected(
  items: ApiSpecs['/bm/cart']['GET']['response']['cartItems'],
) {
  return items.some((item) =>
    item.options.some((option) =>
      option.choices.some(
        (choice) => choice.isCollectionPoint && choice.selected,
      ),
    ),
  )
}
